var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import * as React from 'react';
import styled from 'styled-components';
import { MaxWidth } from '../../layout';
import { displaySmall } from '../../constants/typography';
import { borderRadius, color, opacity, spacing, controls, dimension } from '../../constants';
var Nav = styled.nav(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  height: ", ";\n  background-color: ", ";\n"], ["\n  width: 100%;\n  height: ", ";\n  background-color: ", ";\n"])), dimension.height.primaryNav, color.theme.primaryNav.background);
export var PrimaryNavLink = styled.a(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: inline-flex;\n  align-items: center;\n  height: ", ";\n  border: 0;\n  padding: 0 ", ";\n  margin: 0;\n  border-radius: ", ";\n  opacity: ", ";\n  background-color: ", ";\n\n  cursor: ", ";\n  color: ", ";\n  text-decoration: none;\n  ", ";\n\n  &:hover {\n    background-color: ", ";\n  }\n\n  &:active {\n    background-color: ", ";\n  }\n"], ["\n  display: inline-flex;\n  align-items: center;\n  height: ", ";\n  border: 0;\n  padding: 0 ", ";\n  margin: 0;\n  border-radius: ", ";\n  opacity: ", ";\n  background-color: ",
    ";\n\n  cursor: ",
    ";\n  color: ", ";\n  text-decoration: none;\n  ", ";\n\n  &:hover {\n    background-color: ",
    ";\n  }\n\n  &:active {\n    background-color: ",
    ";\n  }\n"])), controls.height.default, spacing.snug, borderRadius.large, function (_a) {
    var _b = _a.isDisabled, isDisabled = _b === void 0 ? false : _b;
    return (isDisabled ? opacity.subtle : 1);
}, function (_a) {
    var _b = _a.isActive, isActive = _b === void 0 ? false : _b;
    return isActive
        ? color.theme.primaryNav.state.currentActive.background + " !important"
        : 'transparent';
}, function (_a) {
    var _b = _a.isDisabled, isDisabled = _b === void 0 ? false : _b, _c = _a.isActive, isActive = _c === void 0 ? false : _c;
    return isDisabled || isActive ? 'not-allowed !important' : 'pointer';
}, color.theme.primaryNav.state.currentActive.foreground, displaySmall, function (_a) {
    var _b = _a.isDisabled, isDisabled = _b === void 0 ? false : _b;
    return isDisabled ? 'inherit' : color.theme.primaryNav.state.hover.background;
}, function (_a) {
    var _b = _a.isDisabled, isDisabled = _b === void 0 ? false : _b;
    return isDisabled ? 'inherit' : color.theme.primaryNav.state.active.background;
});
export var PrimaryNav = function (_a) {
    var className = _a.className, children = _a.children;
    return (React.createElement(Nav, { className: className },
        React.createElement(MaxWidth, null, children)));
};
var templateObject_1, templateObject_2;
//# sourceMappingURL=index.js.map